module.exports = __webpack_public_path__ + "img/admin.e4794a1e.svg";